









export default {
  name: 'ConsultationItemBlock',
  props: {
    header: String,
    data: String,
  },
  data() {
    return {
      open: false,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/consultations/components/ConsultationItemBlock.vue